import { useState, useEffect, useCallback } from 'react';
import { supabase } from '../supabaseClient';

export function useProfile(userId) {
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [needsSetup, setNeedsSetup] = useState(false);
  const [profileLoaded, setProfileLoaded] = useState(false);

  const fetchProfile = useCallback(async () => {
    if (!userId) { setLoading(false); setProfileLoaded(false); return; }
    setLoading(true);
    setProfileLoaded(false);
    const { data } = await supabase
      .from('profiles')
      .select('*')
      .eq('id', userId)
      .single();

    if (data?.display_name) {
      setProfile(data);
      setNeedsSetup(false);
    } else {
      setNeedsSetup(true);
    }
    setLoading(false);
    setProfileLoaded(true);
  }, [userId]);

  useEffect(() => { fetchProfile(); }, [fetchProfile]);

  const saveProfile = async ({ display_name, avatar_emoji }) => {
    const { data, error } = await supabase
      .from('profiles')
      .upsert({ id: userId, display_name: display_name.trim(), avatar_emoji: avatar_emoji || '📓' })
      .select()
      .single();
    if (!error && data) {
      setProfile(data);
      setNeedsSetup(false);
    }
    return error;
  };

  return { profile, loading, needsSetup, profileLoaded, saveProfile, fetchProfile };
}
